import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Card } from "@/components/layout/Card";
import { BRAND_PURPLE } from "@/css/constants";

export const INTERACTIVE_STYLES = `
  position: relative;
  border: 1px solid transparent;
  transition: all 100ms ease;
  &:hover {
    border-color: ${BRAND_PURPLE};
  }
  &.active {
    border: 1px solid ${BRAND_PURPLE};
  }
  &.inactive {
    background-color: ${Colors.LIGHT_GRAY5};
    color: ${Colors.GRAY3};
    border-color: transparent;
  }
  &.inactive-grey-icon {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    border-color: transparent;
  }
`;

export const OptionCard = styled(Card)`
  ${INTERACTIVE_STYLES}
`;
